import Box from '@mui/material/Box';
import {
    Button, CircularProgress, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer,
    TableRow, Typography, useMediaQuery
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import CloseIcon from '@mui/icons-material/Close';
import { TempPartnerSignup } from '../../../app/models/partners';
import { adminUserStyles } from '../adminUsers/adminUserStyles';

interface Propsaaa {
    partnerData: TempPartnerSignup;
}
const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#B6DAFF',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
    })
};

const AdminPartnerTempResendModal = ({ partnerData }: Propsaaa) => {

    const { modalStore, partnerStore } = useStore();
    const { closeModal } = modalStore;
    const { resendEmailTempsignup, resendEmailTempLoading } = partnerStore;

    const matches = useMediaQuery('(min-width:900px)');

    const closeModalHandler = () => {
        closeModal();
    }
    const resendEmailHandler = (id: string) => {
        resendEmailTempsignup(id);
    }
    if (!partnerData)
        return null;
    return (
        <Box sx={style(matches)}>
            <Typography variant='h6' textAlign='center'>{partnerData.username}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table" >
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        It will resend an email to : {partnerData.emailId}<br />
                                        Email expire will be extended by 7 days from now.
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {!resendEmailTempLoading ?
                        <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            pt={2}
                        >

                            <Button variant='contained' onClick={() => resendEmailHandler(partnerData.id)}>Resend email</Button>
                            <Button size={matches ? "medium" : "small"} variant="contained" onClick={closeModalHandler}
                                startIcon={<CloseIcon />}>Close</Button>
                        </Stack>
                        :
                        <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            pt={2}
                        >

                            <CircularProgress size='1.2em' />
                        </Stack>
                    }
                </Grid>
            </Grid>
        </Box>
    )
}
export default observer(AdminPartnerTempResendModal);